import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const picApi = AiseaApiFactory.get("picture");
const eplApi = AiseaApiFactory.get("enterpriseLicense");
const eplpApi = AiseaApiFactory.get("enterpriseLicensePicture");

export default {
  async setCurrentLicenseData({ commit }, payload) {
    let user = {
      id: payload.userId,
      licenseId: payload.license.id
    };
    commit("SET_USER", user);

    if (payload.license.pictures.length !== 0) {
      let picture = {
        id: payload.license.pictures[0].picture.id,
        licenseId: payload.license.pictures[0].id,
        imgSrc: payload.imgSrc
      };
      commit("SET_PICTURE", picture);
    } else {
      commit("SET_PICTURE", { imgSrc: null });
    }

    let inputForm = {
      name: payload.license.name,
      licenseTypeId: payload.license.licenseTypeId,
      expirationDate: payload.license.expirationDate,
      memo: payload.license.memo,
    };
    commit("SET_INPUT_FORM", inputForm);
  },

  async setInputForm({ commit }, payload) {
    commit("SET_INPUT_FORM", payload);
  },

  async setSelectedLicenseCategory({ commit }, payload) {
    commit("SET_SELECTED_LICENSE_CATEGORY", payload);
  },

  async setPictureUrl({ commit }, payload) {
    commit("SET_PICTURE_URL", payload);
  },

  async setPictureSrc({ commit }, payload) {
    commit("SET_PICTURE_SRC", payload);
  },

  async saveLicense({ commit, state }) {
    let payload = state.inputForm;
    let updateRes = await eplApi.update(state.user.id, state.user.licenseId, payload);

    if(state.pictureSrc) {
      let formData = new FormData();
      formData.append("data", state.pictureSrc);
      let pRes = await picApi.addLicensePicture({ formData: formData })
      let linkToRes = await eplpApi.linkTo(state.user.id, updateRes.data.id, {
        id: pRes.data.id
      });
      let picture = {
        id: pRes.data.id,
        licenseId: linkToRes.data.id,
        imgSrc: null
      };
      commit("SET_PICTURE", picture);
    }
  },

  async deletePicture({ state }) {
    await eplpApi.unlinkTo(state.user.id, state.user.licenseId, state.picture.licenseId)
  },

  async resetLicenseEditState({ commit }) {
    let defaultState = {
      user:null,
      license: null,
      picture: null,
      editLicenceCategory: null,
      selectedLicenseCategory: null,
      inputForm: {},
      pictureSrc: null,
    };
    commit("RESET_STATE", defaultState);
  }
};
